document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('formModal');
    const openBtn = document.getElementById('openCreateDocModal');
    const closeBtn = document.getElementById('closeModal');
    const select = document.getElementById('destinatarioSelect');
    if(openBtn && closeBtn && modal && select) {
        openBtn.addEventListener('click', async () => {
            modal.classList.remove('hidden');
            document.getElementById('nuevoArchivosContainer').innerHTML = '';
        });
        closeBtn.addEventListener('click', () => modal.classList.add('hidden'));

    }


    document.querySelectorAll('.openEditDocModal').forEach(btn => {
        btn.addEventListener('click', async () => {
            const id = btn.dataset.id;
    
            const res = await fetch(`/admin/documentos/${id}/edit`);
            const data = await res.json();
    
            document.querySelector('#formModal h2').textContent = 'Editar Documento';
            document.querySelector('#formModal form').action = `/admin/documentos/${id}`;
            document.querySelector('#formModal input[name="_method"]').value = 'PUT';
            document.querySelector('#formModal input[name="titulo"]').value = data.titulo;
            document.querySelector('#formModal textarea[name="descripcion"]').value = data.descripcion;
            document.querySelector('#formModal select[name="destinatario"]').value = data.destinatario;
            if(data.destinatario === 'grupo_local') {
                document.querySelector('#grupoLocalesContainer').style.display = 'block';
            }else if(data.destinatario === 'grupo_tienda') {
                document.querySelector('#grupoTiendasContainer').style.display = 'block';
            } else if(data.destinatario === 'categoria_tienda') {
                document.querySelector('#categoriaTiendasContainer').style.display = 'block';
            } else if(data.destinatario === 'locales_por_categoria_tienda') {
                document.querySelector('#categoriaTiendasContainer').style.display = 'block';
            }
            
            //Quitar el required del archivo
            const archivosInput = document.querySelector('#formModal input[name="archivos[]"]');
            if (archivosInput) {
                archivosInput.removeAttribute('required');
            }
    
            document.getElementById('nuevoArchivosContainer').innerHTML = '';
            document.getElementById('formModal').classList.remove('hidden');
        });
    });
    $('.deleteDoc').on('click', function (e) {
        e.preventDefault();
        const id = $(this).data('id');
    
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Sí, eliminar'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: `/admin/documentos/${id}`,
                    method: 'POST',
                    data: { _method: 'DELETE', _token: $('meta[name="csrf-token"]').attr('content') },
                    success: function (response) {
                        Swal.fire('Eliminado', response.success || 'El registro ha sido eliminado.', 'success')
                            .then(() => location.reload());
                    },
                    error: function () {
                        Swal.fire('Error', 'No se pudo eliminar el registro.', 'error');
                    }
                });
            }
        });
    }); 
    $('.deleteArchivo').on('click', function (e) {
        e.preventDefault();
        const id = $(this).data('id');
    
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Sí, eliminar'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: `/admin/documentos/archivo/${id}`,
                    method: 'POST',
                    data: { _method: 'DELETE', _token: $('meta[name="csrf-token"]').attr('content') },
                    success: function (response) {
                        console.log(response);
                        Swal.fire('Eliminado', response.success || 'El registro ha sido eliminado.', 'success')
                            .then(() => location.reload());
                    },
                    error: function () {
                        Swal.fire('Error', 'No se pudo eliminar el registro.', 'error');
                    }
                });
            }
        });
    }); 
    // Agregar evento para el botón de agregar nuevo archivo
    const addArchivoBtn = document.getElementById('addArchivoBtn');
    const nuevoArchivosContainer = document.getElementById('nuevoArchivosContainer');
    if(!addArchivoBtn || !nuevoArchivosContainer) return;
    addArchivoBtn.addEventListener('click', () => {
        const div = document.createElement('div');
        div.classList.add('d-flex', 'align-items-center', 'mb-2');
        div.innerHTML = `
            <input type="file" name="archivos[]" accept="application/pdf" class="form-control me-2" required>
            <button type="button" class="btn btn-outline-danger eliminar-nuevo-archivo">Eliminar</button>
        `;
        nuevoArchivosContainer.appendChild(div);
    });

    nuevoArchivosContainer.addEventListener('click', (e) => {
        if (e.target.classList.contains('eliminar-nuevo-archivo')) {
            e.target.parentElement.remove();
        }
    });
    //Destinatarios
    const destinatarioSelect = document.getElementById('destinatarioSelect');

    const containers = {
        grupoLocales: document.getElementById('grupoLocalesContainer'),
        grupoTiendas: document.getElementById('grupoTiendasContainer'),
        categoriaTiendas: document.getElementById('categoriaTiendasContainer'),
    };

    function toggleContainers(value) {
        Object.values(containers).forEach(container => container.style.display = 'none');

        if (value === 'grupo_local') {
            containers.grupoLocales.style.display = 'block';
        } else if (value === 'grupo_tienda') {
            containers.grupoTiendas.style.display = 'block';
        } else if (value === 'categoria_tienda' || value === 'locales_por_categoria_tienda') {
            containers.categoriaTiendas.style.display = 'block';
        }
    }

    destinatarioSelect.addEventListener('change', (e) => {
        toggleContainers(e.target.value);
    });

    // Inicializar por si ya hay un valor cargado
    toggleContainers(destinatarioSelect.value);

});
